import { render, staticRenderFns } from "./testLayout.vue?vue&type=template&id=26747bae&scoped=true"
import script from "./testLayout.vue?vue&type=script&lang=js"
export * from "./testLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26747bae",
  null
  
)

export default component.exports